export const ucscTF =
  "https://genome.ucsc.edu/cgi-bin/hgTracks?hgS_doOtherUser=submit&hgS_otherUserName=PimandaLab&hgS_otherUserSessionName=BloodChiP_Xtra_TF&position=";
export const ucscEpi =
  "https://genome.ucsc.edu/cgi-bin/hgTracks?hgS_doOtherUser=submit&hgS_otherUserName=PimandaLab&hgS_otherUserSessionName=BloodChiP_Xtra_epigenetics&position=";
export const ucscATAC =
  "https://genome.ucsc.edu/cgi-bin/hgTracks?hgS_doOtherUser=submit&hgS_otherUserName=PimandaLab&hgS_otherUserSessionName=BloodChiP_Xtra_ATAC&position=";
